import React from "react";

import {
	TabsContentContainer,
	FilterContainer,
	ActionsContainer,
	TableContainer,
	Filters,
} from "components";
import { pendAppFilterInitialValues } from "models";
import { applicationListService } from "services";

import ApplicationsActions from "../applicationsActions";
import ApplicationsTable from "../applicationsTable";
import * as filter from "../filterColumns";
import * as table from "../tableColumns";

const filterColumns = [
	filter.applicationIdColumn(),
	filter.midColumn(),
	filter.merchantNameColumn(),
	filter.merchantStatusColumn(),
	filter.processorColumn(),
	filter.sponsorColumn(),
	filter.agentOfficeColumn(),
	filter.agentNameColumn(),
	filter.applicationStatusColumn(),
	filter.pendStatusColumn(),
	filter.pendedToColumn(),
	filter.assignedToColumn(),
];

const tableColumns = [
	table.nailSoftColumn(),
	table.applicationIdColumn(),
	table.midColumn(),
	table.merchantNameColumn(),
	table.merchantStatusColumn(),
	table.proseccorSponsorColumn(),
	table.agentOfficeAgentNameColumn(),
	table.applicationStatusColumn(),
	table.ageInApplicationColumn(),
	table.ageInStatusColumn(),
	table.pendStatusColumn(),
	table.pendedToColumn(),
	table.ageOfPendColumn(),
	table.assignedToColumn(),
	table.applicationListActionsColumn({
		showInlineEditButton: false,
		showRemoveButton: false,
	}),
];

const form = "applicationsFiltersPended";

const PendedTab = () => {
	return (
		<TabsContentContainer className="container-flex">
			<FilterContainer>
				<Filters
					form={form}
					columns={filterColumns}
					initialValues={pendAppFilterInitialValues}
				/>
			</FilterContainer>
			<ActionsContainer className="m-0">
				<ApplicationsActions />
			</ActionsContainer>
			<TableContainer>
				<ApplicationsTable
					getList={applicationListService.getPended}
					columns={tableColumns}
					form={form}
				/>
			</TableContainer>
		</TabsContentContainer>
	);
};

export default PendedTab;
